<template>
  <div class="password-modal as-flex flex-vertical main-start cross-center">
    <div class="indicator-title as-flex main-center cross-center f-4">
      <div class="title-center">{{defaultConfig.type === 'change'?'修改密码':'重置密码'}}</div>
      <div class="title-close" @click="close">
        <img src="../../assets/images/close-3x.png" height="100%" width="100%">
      </div>
    </div>
    <div class="indicator-content as-flex flex-vertical main-start cross-center">
      <div class="mobile-row as-flex main-start cross-center">
        <input v-model="mobile" type="text" placeholder="请输入手机号">
      </div>
      <div class="validation-row as-flex main-start cross-center">
        <input v-model="code" type="text" placeholder="短信验证码">
        <div
          :class="['getValidationCode' ,'as-flex', 'main-center', 'cross-center' ,'f-1' ,countDown?'is-counting':'']"
          @click="getCode"
        >{{countDown?`${countDown}s后重发` : '获取验证码' }}</div>
      </div>
      <div class="mobile-row as-flex main-start cross-center">
        <input v-model="passwd" type="password" placeholder="请输入新密码">
      </div>
      <div class="mobile-row as-flex main-start cross-center">
        <input v-model="passwd_repeat" type="password" placeholder="请再次输入新密码">
      </div>
      <div class="error f-1">{{error}}</div>
      <div class="confirm-btn as-flex main-center cross-center f-3" @click="confirm">确定</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    defaultConfig: {}
  },
  components: {},
  data() {
    return {
      error: undefined,
      mobile: undefined,
      code: undefined,
      countDown: undefined,
      //change
      // current_passwd: undefined,
      // new_passwd: undefined,
      // repeat_new_passwd: undefined,
      //reset
      passwd: undefined,
      passwd_repeat: undefined
    };
  },
  methods: {
    clearData() {
      this.mobile = undefined;
      this.code = undefined;
      this.passwd = undefined;
      this.passwd_repeat = undefined;
    },
    clearError() {
      this.error = undefined;
    },
    close() {
      this.clearError();
      this.$emit("close");
    },
    startCountDown(time) {
      this.countDown = time;
      setTimeout(() => {
        if (this.countDown > 0) {
          this.countDown--;
          this.startCountDown(this.countDown);
        } else {
          this.countDown = undefined;
        }
      }, 1000);
    },
    async getCode() {
      if (this.countDown) {
        return;
      }
      if (!this.mobile || this.mobile.length !== 11) {
        this.$message({
          message: "请输入正确的手机号",
          type: "error"
        });
        return;
      } else {
        this.clearError();
        let res = await this.$store.dispatch("user/getCode", {
          mobile: this.mobile,
          category: this.defaultConfig.type === "reset" ? 3 : 2
        });
        if (res.code === 200) {
          this.startCountDown(60);
          this.$message({
            message: "已成功发送验证码",
            type: "success"
          });
        } else {
          this.$message({
            message: res.msg,
            type: "error"
          });
        }
      }
    },
    async confirm() {
      if (!this.validate()) {
        return;
      }
      this.clearError();
      if (this.defaultConfig.type === "change") {
        await this.reset();
      } else if (this.defaultConfig.type === "reset") {
        await this.reset();
      }
    },
    validate() {
      if (!this.mobile || this.mobile.length !== 11) {
        this.error = "请输入十一位手机号码";
        return false;
      } else if (!this.code || this.code.length !== 6) {
        this.error = "请填写六位验证码";
        return false;
      } else if (!this.passwd || this.passwd.length < 6) {
        this.error = "请输入不少于六位的密码";
        return false;
      } else if (this.passwd !== this.passwd_repeat) {
        this.error = "两次填写的密码不一致";
        return false;
      }
      return true;
    },

    async reset() {
      if (this.passwd !== this.passwd_repeat) {
        this.error = "两次填写的密码不一致";
        return;
      }
      this.clearError();
      let res = await this.$store.dispatch("user/resetPasswd", {
        mobile: this.mobile,
        captcha: this.code,
        password: this.passwd
      });
      if (res.code === 200) {
        this.$message({
          message: "重置密码成功",
          type: "success"
        });
        this.$store.dispatch("user/updateUserInfo", {
          mobile: this.mobile,
          captcha: this.captcha,
          password: this.passwd
        });
        this.clearData();
        this.close();
      } else {
        this.$message({
          message: res.msg,
          type: "error"
        });
      }
    }
  },
  watch: {
    code: function(to, from) {
      //验证码最多六位
      if (to && to.length > 6) {
        this.code = to.slice(0, 6);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.password-modal {
  width: 100%;
  height: 100%;
  padding: 10px;
}
.indicator-title {
  height: 20px;
  width: 100%;
  margin: 10px 0;
  position: relative;
  .title-close {
    position: absolute;
    left: 0;
    top: 0;
    width: 20px;
    height: 20px;
  }
}
.indicator-content {
  width: 100%;
  height: 100%;
  padding: 10px 15px;
  .mobile-row {
    // height: 20%;
    margin: 10px;
    width: 100%;
  }
  .validation-row {
    // height: 20%;
    width: 100%;
    position: relative;
  }
  .getValidationCode {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 0;
    height: 2em;
    width: 5rem;
    border-radius: 0.3rem;
    color: #61b6e6;
    &.is-counting {
    }
  }
  .confirm-btn {
    width: 50%;
    height: 2.5em;
    background-color: #61b6e6;
    border-radius: 1.25em;
    color: #fff;
  }
  .error {
    height: 1.5em;
    width: 100%;
    margin: 10px 0;
    color: red;
  }
}

input {
  font-size: 13px;
  outline: none;
  height: 40px;
  width: 100%;
  color: #999999;
  border: none;
  border-bottom: 1px solid #eee;
}
input::hover {
  outline: none;
}
</style>
